import { Route } from 'react-router-dom'
import { ID } from '../utils'
import ResidentCommunicationRecordsScreen from 'screens/Residents/screens/ResidentCommunicationRecordsScreen/ResidentCommunicationRecordsScreen'
import { ResidentProceduresScreen } from 'screens/Residents/screens/ResidentProceduresScreen/ResidentProceduresScreen'
import { ResidentReferralsScreen } from 'screens/Residents/screens/ResidentReferralsScreen'
import { ResidentServiceRecordsScreen } from 'screens/Residents/screens/ResidentServiceRecordsScreen'
import { ResidentTransferRecordsScreen } from 'screens/Residents/screens/ResidentTransferRecordsScreen'
import { ResidentDeviceRecordsScreen } from 'screens/Residents/screens/ResidentDeviceRecordsScreen'

export const healthRecordsRoutes = () => {
  const routes = []
  routes.push(
    <Route
      key="communication-records"
      path={`${ID}/communication-records`}
      element={<ResidentCommunicationRecordsScreen />}
    />
  )

  routes.push(
    <Route
      key="procedures"
      path={`${ID}/procedures`}
      element={<ResidentProceduresScreen />}
    />
  )

  routes.push(
    <Route
      key="referrals"
      path={`${ID}/referrals`}
      element={<ResidentReferralsScreen />}
    />
  )

  routes.push(
    <Route
      key="service-records"
      path={`${ID}/service-records`}
      element={<ResidentServiceRecordsScreen />}
    />
  )

  routes.push(
    <Route
      key="transfer-records"
      path={`${ID}/transfer-records`}
      element={<ResidentTransferRecordsScreen />}
    />
  )

  routes.push(
    <Route
      key="device-records"
      path={`${ID}/device-records`}
      element={<ResidentDeviceRecordsScreen />}
    />
  )

  return <>{routes}</>
}
